import { render, staticRenderFns } from "./checkPage.vue?vue&type=template&id=10552d34&scoped=true&"
import script from "./checkPage.vue?vue&type=script&lang=js&"
export * from "./checkPage.vue?vue&type=script&lang=js&"
import style0 from "./checkPage.vue?vue&type=style&index=0&id=10552d34&scoped=true&lang=css&"
import style1 from "./checkPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10552d34",
  null
  
)

export default component.exports